<template>
    <div>
        <portal to="error" v-if="hasError">
            <modal @close="deleteError">
                <template slot="header">Fehler</template>

                <div v-show="status === 401">
                    <p>Bitte einloggen.</p>
                </div>

                <div v-show="status === 403">
                    <p>Nicht erlaubte Benutzung</p>

                    <p>{{ response.data.message }}</p>
                </div>

                <div v-show="status === 404">
                    <p>Seite nicht gefunden</p>

                    <p>{{ response.data.message }}</p>
                </div>

                <div v-show="status === 413">
                    <p>Datei ist zu groß</p>
                </div>

                <div v-show="status === 429">
                    Zu viele Anfragen. Bitte warte eine Minute.
                </div>

                <div v-show="status === 422">
                    <p>Die eingegebenen Daten waren ungültig.</p>

                    <p v-for="(errors, field) in response.data.errors" class="mt-2">
                        {{ field }}: <span v-for="error in errors">{{ error }}</span>
                    </p>
                </div>

                <div v-show="status === 500">
                    Wir arbeiten gerade an der Verbesserung deiner App - versuch es einfach später noch einmal.
                </div>

                <div v-show="isUnknown">
                    <h1>{{ response }}</h1>
                    Ein Fehler ist aufgetreten.

                    {{ response }}
                </div>

            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from "./Modal";

export default {
    name: "ErrorResponse",

    components: {Modal},

    props: ['error'],

    computed: {
        hasError() {
            return this.error !== null;
        },
        response() {
            return this.error.response;
        },
        status() {
            return this.response?.status ?? 500;
        },
        isUnknown() {
            return ![401, 403, 404, 413, 422, 429, 500].includes(this.status);
        }
    },

    methods: {
        deleteError() {
            this.$emit('delete');
        },
    },
}
</script>

<style scoped>

</style>
